<button [class]="nonDefaultColor ? color : 'default'" (click)="onPress()">
    <span class="prevent-selection" [class]="{ bold: bold }">{{ label }}</span>
</button>